import service from '@/utils/request'
import cache from '@/utils/cache'
import constant from '@/utils/constant'
import store from "@/store";
import {AxiosResponse} from "axios";

export interface IUserProperty {
    "id"?: string,
    "userId"?: string,
    "userName"?: string,
    "propType"?: string,
    "propTypeLabel"?: string,
    "propName"?: string,
    "propNameLabel"?: string,
    "propValue"?: string,
    "propLabel"?: string,
    "propUnit"?: string,
    "propRemark"?: string,
    "orderNum"?: number,
    "perm"?: string,
    "style"?: string,
    "description"?: string,
    "status"?: boolean,
    "createId"?: string,
    "updateId"?: string,
    "createTime"?: number | Date,
    "updateTime"?: number | Date
}

export interface IUserInfo {
    "id"?: number,
    "username"?: string,
    "realName"?: string,
    "avatar"?: string,
    "gender"?: 0 | 1 | 2 , // 性别 0：男 1：女 2：未知
    "email"?: string,
    "mobile"?: string,
    "mobileValidated"?: boolean,
    "orgId"?: number,
    "orgInfo"?: string,
    "orgPerm"?: string,
    "emergencyContact"?: string,
    "status"?: number | boolean,
    "roleIdList"?: number[],
    "postIdList"?: number[],
    "properties"?: IUserProperty[],
    "superAdmin"?: boolean,
    "orgName"?: string,
    "online"?: boolean,
    "createTime"?: number | Date
}

export const useUserInfoApi = () => {
    return service.get<IUserInfo>('/sys/user/info')
}

export const updatePasswordApi = (data: any) => {
    return service.put('/sys/user/password', data)
}

export const useUserApi = (id: number) => {
    return service.get<IUserInfo>('/sys/user/' + id)
}

export const useUserExportApi = () => {
    location.href = constant.apiUrl + '/sys/user/export?access_token=' + cache.getToken()
}

export const useUserTokenListApi = () => {
    return service.get('/sys/auth/user/token')
}

export const useUserSubmitApi = (dataForm: IUserInfo) => {
    if (dataForm.id) {
        return service.put('/sys/user', dataForm)
    } else {
        return service.post('/sys/user', dataForm)
    }
}

export enum EUserRole {
    SuperAdmin, AreaAdmin, DoctAdmin, Doctor, User, SubUser
}


export const getUserRole = async (): Promise<EUserRole> => {
    let roleList = store.userStore?.user?.roleList || [];

    if (roleList.length === 0) {
        const userInfo = await useUserInfoApi()
        store.userStore?.setUser(userInfo.data)
        roleList = userInfo.data.roleIdList
    }

    if (roleList?.indexOf(1) >= 0) {
        return EUserRole.SuperAdmin
    }

    if (roleList?.indexOf(7) >= 0) {
        return EUserRole.DoctAdmin
    }

    if (roleList?.indexOf(2) >= 0) {
        return EUserRole.AreaAdmin
    }

    if (roleList?.indexOf(6) >= 0) {
        return EUserRole.SubUser
    }

    if (roleList?.indexOf(8) >= 0) {
        return EUserRole.Doctor
    }

    return EUserRole.User
}

/**
 * 批量更新用户(自己)属性
 * @param data
 */
export const useBatchUpdateUserPropsApi = (data: IUserProperty[]) => {
    return service.post('/app/user/properties', data)
}
